import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import React, { useState, useEffect, useRef } from 'react';
import apis from '../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import TimePicker from '../TimePicker/TimePicker';
import { Toolbar } from 'primereact/toolbar';
import { excelExport } from '../../services/excelExport.service';
import { excelReport } from '../../services/excelReport.service';
import { FileUpload } from 'primereact/fileupload';
import { saveAs } from 'file-saver';
import { ProgressSpinner } from 'primereact/progressspinner';
import { addLocale } from 'primereact/api'
import { Avatar } from 'primereact/avatar';

const Marking = () => {
    const [markings, setMarkings] = useState([])
    const [scheduleList, setScheduleList] = useState([])
    const [causeList, setCauseList] = useState([])

    const [loadPage, setLoadPage] = useState(false);
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loading5, setLoading5] = useState(false)
    const [loading6, setLoading6] = useState(false)
    const [isOpenMarking, setIsOpenMarking] = useState(false)
    const [isOpenSchedulingUpdate, setisOpenMarkingUpdate] = useState(false)
    const [isOpenSchedulingDelete, setIsOpenMarkingDelete] = useState(false)

    const headers = { Authorization: localStorage.getItem("token") }
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')

    const [markingId, setMarkingId] = useState("")
    const [schedule, setSchedule] = useState("")
    const [cause, setCause] = useState("")
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")

    const [loadingExport, setLoadingExport] = useState(false);
    const [exportContent, setExportContent] = useState([])
    const [isOpenCargue, setIsOpenCargue] = useState(false);
    const fileUploadRef = useRef(null);
    const [consultado, setConsultado] = useState(false);
    const [isOpenProcess, setIsOpenProcess] = useState(false);

    const [errorMsg, setErrorMsg] = useState("")
    const [isOpenError, setIsOpenError] = useState(false)
    
    const toast = useRef(null);

    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [markingsSelected, setMarkingsSelected] = useState([]);
    const [scheduleSelected, setScheduleSelected] = useState(null);
    const [buttonClicked, setButtonClicked] = useState(false)
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    useEffect(() => {
        getMarkingList()
        getMarking()
    }, [])

    const hideModalMarking = () => {
        setSchedule("")
        setStartTime("")
        setEndTime("")
        setCause("")
        setScheduleSelected([])
        setButtonClicked(false)
        setIsOpenMarking(false)
    }

    const hideModalMarkingUpdate = () => {
        setSchedule("")
        setStartTime("")
        setEndTime("")
        setCause("")
        setScheduleSelected([])
        setButtonClicked(false)
        setMarkingId("")
        setisOpenMarkingUpdate(false)
    }

    const hideModalMarkingDelete = () => {
        setSchedule("")
        setStartTime("")
        setEndTime("")
        setCause("")
        setScheduleSelected([])
        setButtonClicked(false)
        setMarkingId("")
        setIsOpenMarkingDelete(false)
    }

    const showModalCargue = () => {
        setIsOpenCargue(true);
    };

    const hideModalCargue = () => {
        setIsOpenCargue(false);
    };

    const showModalProcess = () => {
        setIsOpenProcess(true);
    };

    const hideModalProcess = () => {
        setIsOpenProcess(false);
    };

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
                </IconField>
            </div>
        )
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];
    
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
            { label: 5, value: 5 },
            { label: 10, value: 10 },
            { label: 20, value: 20 }
            ];

            return (
            <React.Fragment>
                <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
            </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
            <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                {options.first} - {options.last} of {options.totalRecords}
            </span>
            )
        }
    };

    const template3 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'CurrentPageReport': (options) => {
            return (
            <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                {options.first} - {options.last} of {options.totalRecords}
            </span>
            )
        }
    };

    const getMarkingList = async () => {
        try{
            await apis.markingList(entity, client, headers).then(res => { 
                setScheduleList(res.data.SCHEDULING)
                setCauseList(res.data.TRK_APD_CAUSAL)
            })
        }
        catch(error){
            console.log(error)
        }
    }

    const getMarking = async () => {
        setLoadPage(false)
        try{
            await apis.getMarking(entity, client, headers).then(res => {
                let data = []
                let exportData = []
                res.data.SHIFTS_MARKING.forEach(shift => {
                    const contract_ = shift.CONTRACT_ID.split('|')
                    const cause_ = shift.LOV_CAUSAL.split('|')
                    const status_ = shift.STATUS.split('|')
                    const costCenter_ = shift.COST_CENTER_ID.split('|')
                    let newShift= {
                        ...shift,
                        CONTRACT_ID: contract_[0],
                        CONTRACT: contract_[1],
                        LOV_CAUSAL: cause_[0],
                        LOV_CAUSAL_DESC: cause_[1],
                        STATUS: status_[0],
                        STATUS_DESC: status_[1],
                        COST_CENTER_ID: costCenter_[0],
                        COST_CENTER: costCenter_[1],
                    }
                    let newExport = {
                        ID: shift.SHIFT_MARKING_ID,
                        'ID programación': shift.PROGRAM_SHIFT_ID,
                        Contrato: contract_[0],
                        Nombre: contract_[1],
                        'Fecha programación': shift.PROGRAM_DATE,
                        'Hora inicio': shift.START_TIME,
                        'Hora fin': shift.END_TIME,
                        RDF: shift.RDF,
                        RN: shift.RN,
                        RNF: shift.RNF,
                        HED: shift.HED,
                        HEDF: shift.HEDF,
                        HEN: shift.HEN,
                        HENF: shift.HENF,
                        'Total RN': shift.TOTAL_RN,
                        'Total HE': shift.TOTAL_HE,
                        'Centro de costo contable': costCenter_[1],
                        'Código centro de costo contable': costCenter_[0],
                        'Estado': status_[1],
                        'Causal': cause_[1],
                    }
                    data.push(newShift)
                    exportData.push(newExport)
                    
                })
                console.log(data)
                setExportContent(exportData)
                setMarkings(data)
            })
        }
        catch(error){
            console.log(error)
        }
        finally{
            setLoadPage(true)
        }
    }

    const postMarking = async () => {
        setLoading1(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                PROGRAM_SHIFT_ID: schedule.PROGRAM_SHIFT_ID,
                START_TIME: startTime,
                END_TIME: endTime,
                LOV_CAUSAL: cause && cause.detail_id
            }
            await apis.postMarking(payload, headers).then(res => {
                getMarking()
                hideModalMarking()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Marcación creada exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading1(false)
        }
    }

    const putMarking = async () => {
        setLoading2(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                SHIFT_MARKING_ID: markingId,
                PROGRAM_SHIFT_ID: schedule.PROGRAM_SHIFT_ID,
                START_TIME: startTime,
                END_TIME: endTime,
                LOV_CAUSAL: cause && cause.detail_id
            }
            await apis.putMarking(payload, headers).then(res => {
                getMarking()
                hideModalMarkingUpdate()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Marcación actualizada exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading2(false)
        }
    }

    const deleteMarking = async () => {
        setLoading3(true)
        try{
            await apis.delMarking(entity, client, markingId, headers).then(res => {
                getMarking()
                hideModalMarkingDelete()
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: "Marcación eliminada exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading3(false)
        }
    }

    const processMarking = async () => {
        setLoading6(true)
        try{
            const markings = markingsSelected.map(mrk => {
                return mrk.SHIFT_MARKING_ID
            })
            const payload = {
                CLIENT: client,
                ENTITY: entity,
                SHIFT_MARKING: markings
            }
            await apis.processMarking(payload, headers).then(res => {
                hideModalProcess()
                setMarkingsSelected([])
                getMarking()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading6(false)
        }
    }

    const setMarkingData = (rowData) => {
        const schedule_ = scheduleList.filter(cont => cont.PROGRAM_SHIFT_ID === rowData.PROGRAM_SHIFT_ID)[0]
        const cause_ = causeList.filter(cau => cau.detail_id === rowData.LOV_CAUSAL)[0]
        setMarkingId(rowData.SHIFT_MARKING_ID)
        console.log(schedule_)
        setSchedule(schedule_)
        setCause(cause_)
        setStartTime(rowData.START_TIME)
        setEndTime(rowData.END_TIME)
        setisOpenMarkingUpdate(true)
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row gap-1'>
                <Button icon="pi pi-pencil" className="p-button-warning p-button-sm text-xs" onClick={() => setMarkingData(rowData)}/>
                <Button icon="pi pi-trash" className="p-button-danger p-button-sm text-xs" onClick={() => {setMarkingId(rowData.SHIFT_MARKING_ID); setIsOpenMarkingDelete(true)}}/>
            </div>
        )
    }

    const addMarkingFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); hideModalMarking() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading1} onClick={() => postMarking()} disabled={!schedule || !startTime || !endTime}/>
        </div>
    );

    const addMarkingHeader = (
        <div>
            <h3>Agregar marcación</h3>
        </div>
    )

    const updateMarkingFooter = (
        <div>
            <Button onClick={() => { setLoading2(false); hideModalMarkingUpdate() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading2} onClick={() => putMarking()} disabled={!schedule || !startTime || !endTime}/>
        </div>
    );

    const updateMarkingHeader = (
        <div>
            <h3>Editar marcación</h3>
        </div>
    )

    const deleteMarkingFooter = (
        <div>
            <Button onClick={() => { setLoading3(false); hideModalMarkingDelete() }}>Cancelar</Button>
            <Button className="p-button-danger" label="Eliminar" loading={loading3} onClick={() => deleteMarking()} />
        </div>
    );

    const deleteMarkingHeader = (
        <div>
            <h3>¿Desea eliminar la marcación?</h3>
        </div>
    )

    const processMarkingFooter = (
        <div>
            <Button onClick={() => { setLoading6(false); hideModalProcess() }}>Cancelar</Button>
            <Button label="Procesar" loading={loading6} onClick={() => processMarking()} />
        </div>
    );

    const processSchedulingHeader = (
        <div>
            <h3>¿Desea procesar la(s) marcación(es) seleccionada(s)?</h3>
        </div>
    )

    const msgContent = (
        <div>
            <a style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#3b82f6' }}>
            {process.env.REACT_APP_DISABLE_MSG}
            </a>
        </div>
    )

    const exportExcel = () => {
        try{
            excelExport(exportContent, 'Marcaciones')
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Exportado con éxito" });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error al exportar", sticky: true });
        }
        finally{
            setLoadingExport(false);
        }
    }

    const leftToolbarTemplate = () => {
        return (
            <div className='flex flex-row gap-1'>
                <Button type="button" icon="pi pi-plus" label="Agregar" className="p-button-success p-button-sm" onClick={() => setIsOpenMarking(true)}/>
                <Button label="Cargue" icon="pi pi-upload" className="p-button-success p-button-sm" onClick={showModalCargue} />
                <Button label="Procesar" icon="pi pi-arrow-right-arrow-left" className="p-button-info p-button-sm" onClick={showModalProcess} disabled={markingsSelected.length < 1}/>
            </div>
        )
    }

    const rightToolbarTemplate = () => {
        return (
          <React.Fragment>
            <Button label="Exportar" icon="pi pi-file-excel" tooltip='Exportar información de la tabla' loading={loadingExport}
                tooltipOptions={{ position: 'top' }} className="p-button-success mr-2 p-button-sm" onClick={() => { setLoadingExport(true); exportExcel() }} />
          </React.Fragment>
        )
    }

    async function downloadSampleFile() {
        let payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            OPTION: 2
        }
        let sampleFile = []
        try {
            await apis.uploadMarking(payload, headers).then(res => {
                sampleFile = res.data
                let nombre = sampleFile["SHEETS"][0]["NAME"]
                excelReport(sampleFile, nombre)
                setLoading5(false)
            });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
            setLoading5(false)
        }
    }

    async function loadError(lines) {
        /*Función encargada de generar el archivo txt de errores del cargue*/
        const blob = new Blob([lines], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
        saveAs(blob, "ErroresCargue.txt");
    }

    async function importData(_importedData) {
        /*Función encargada de cargar los datos formateados del archivo Excel para subirlos*/
        try {
            await apis.uploadMarking(_importedData, headers).then(res => {
                setConsultado(false)
                toast.current.clear()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.data.MESSAGE, sticky: true });
                hideModalCargue()
                getMarking()
            })
        }
        catch (err) {
            loadError(err.response.data.message)
            setConsultado(false)
            toast.current.clear()
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "Error al cargar la información. Por favor revisar archivo de errores", sticky: true });
        }
    }

    const showConfirm = () => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'info', sticky: true, content: (
            <div className="flex flex-column" style={{ flex: '1' }}>
                <div className="text-center">
                    <i >
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
                    </i>
                    <p>Cargando información...</p>
                </div>
            </div>
            )
        });
    }

    async function importCargue(e) {
        /*Función encargada de formatear los datos del archivo Excel para subirlos*/
        setConsultado(true);
        showConfirm();
        const file = e.files[0];

        import('xlsx').then(xlsx => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const wb = xlsx.read(e.target.result, { type: 'array', cellText: false, cellDates: true, dense: true });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = xlsx.utils.sheet_to_json(ws, { header: 1, raw: false, dateNF: 'dd/mm/yyyy', defval: "*" });

                // Prepare DataTable
                data.shift();

                let _importedData = {
                    CLIENT: localStorage.getItem('client'),
                    ENTITY: localStorage.getItem('entity'),
                    OPTION: 1,
                    DETAIL: []
                }

                let lines = 1
                data.forEach(row => {
                    let _line = ""
                    row.forEach(element => {
                        _line += element + "|"
                    })
                    _line = _line.slice(0, -1)
                    _importedData.DETAIL.push({ POSITION: lines, LINE: _line })
                    lines++
                })

                importData(_importedData)
            };
            reader.readAsArrayBuffer(file);
        });
    }

    const footerCargue = (
        <div className="flex align-items-end" style={{ marginLeft: "6rem" }}>
            <Button style={{ marginLeft: "-6rem" }} label='Cancelar' onClick={() => { setLoading5(false); hideModalCargue() }} />
            <Button type="button" icon="pi pi-file-excel" label="Plantilla" loading={loading5} onClick={() => { setLoading5(true); downloadSampleFile() }} />
            <FileUpload ref={fileUploadRef} disabled={consultado} chooseOptions={{ label: 'Cargar', icon: 'pi pi-upload' }} mode="basic" name="demo[]" auto
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onSelect={importCargue}>
            </FileUpload>
        </div>
    );

    const headerCargue = (
        <div>
            <h3>Cargar marcaciones</h3>
        </div>
    )

    const handleScheduleSelection = (value) => {
        console.log(value)
        setScheduleSelected(value)
        setSchedule(value)
        setButtonClicked(false)
    }

    const rowClassName = (rowData) => {
        return { 'error-row': (rowData["STATUS_DESC"] === "ERROR") };
    }

    const errorBodyTemplate = (rowData) => {
        const msg = rowData.ERROR ? rowData.ERROR : "No hay errores"
        setErrorMsg(msg)
        return(
            <Button icon='pi pi-search' severity='secondary' rounded text onClick={() => {setIsOpenError(true)}}/>
        )
    }
    
    const headerError = (
        <div>
            <h3>Error marcación</h3>
        </div>
    )

    return(
        <div className="flex flex-wrap align-items-center justify-content-center flex-column align-self-center">
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <Dialog header={addMarkingHeader} footer={addMarkingFooter} visible={isOpenMarking}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalMarking}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">ID programación</label>
                    {
                        !buttonClicked ?
                        <Button label={schedule ? schedule.PROGRAM_SHIFT_ID : 'Seleccione programación'} onClick={() => setButtonClicked(true)}/>
                        :
                        <DataTable className="text-xs" value={scheduleList} paginator paginatorTemplate={template3} first={first2} rows={rows2} onPage={onCustomPage2}
                            selection={scheduleSelected} onSelectionChange={(e) => handleScheduleSelection(e.value)} dataKey="PROGRAM_SHIFT_ID" selectionMode="single"
                            size="small" filters={filters1} filterDisplay="menu"
                        >
                            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                            <Column field="PROGRAM_SHIFT_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                            <Column field="PROGRAM_DATE" header="Fecha programación"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha programación" sortable></Column>
                            <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
                            <Column field="NAME" header="Nombre"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                        </DataTable>

                    }
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Hora inicio</label>
                    <TimePicker value={startTime} onChange={setStartTime}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Hora fin</label>
                    <TimePicker value={endTime} onChange={setEndTime}/>
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Causal</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Causal" value={cause} options={causeList} onChange={(e) => setCause(e.value)} />
                </div>
            </Dialog>
            <Dialog header={updateMarkingHeader} footer={updateMarkingFooter} visible={isOpenSchedulingUpdate}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalMarkingUpdate}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">ID marcación</label>
                    <InputText value={markingId} placeholder="ID marcación" className="p-inputtext-sm" disabled={true}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">ID programación</label>
                    {
                        !buttonClicked ?
                        <Button label={schedule ? schedule.PROGRAM_SHIFT_ID : 'Seleccione programación'} onClick={() => setButtonClicked(true)}/>
                        :
                        <DataTable className="text-xs" value={scheduleList} paginator paginatorTemplate={template3} first={first2} rows={rows2} onPage={onCustomPage2}
                            selection={scheduleSelected} onSelectionChange={(e) => handleScheduleSelection(e.value)} dataKey="PROGRAM_SHIFT_ID" selectionMode="single"
                            size="small" filters={filters1} filterDisplay="menu"
                        >
                            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                            <Column field="PROGRAM_SHIFT_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                            <Column field="PROGRAM_DATE" header="Fecha programación"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha programación" sortable></Column>
                            <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
                            <Column field="NAME" header="Nombre"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                        </DataTable>

                    }
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Hora inicio</label>
                    <TimePicker value={startTime} onChange={setStartTime}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Hora fin</label>
                    <TimePicker value={endTime} onChange={setEndTime}/>
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Causal</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Causal" value={cause} options={causeList} onChange={(e) => setCause(e.value)} />
                </div>
            </Dialog>
            <Dialog header={deleteMarkingHeader} footer={deleteMarkingFooter} visible={isOpenSchedulingDelete}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalMarkingDelete}>
            </Dialog>
            <Dialog header={processSchedulingHeader} footer={processMarkingFooter} visible={isOpenProcess}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalProcess}>
            </Dialog>
            <Dialog header={headerCargue} footer={footerCargue} visible={isOpenCargue}
                position="top" style={{ width: "28rem" }} draggable={false} resizable={false} modal onHide={hideModalCargue}>
                <span>1. Descargue el archivo base, dando click en el botón Plantilla.</span>
                <br />
                <span>2. Diligencie la hoja Upload_shifts_marking_miremuner, teniendo en cuenta las instrucciones de la hoja Instructivo.</span>
                <br />
                <span>3. De click en el botón Cargar para realizar el cargue del archivo previamente diligenciado.</span>
            </Dialog>
            <Dialog header={headerError} visible={isOpenError}
                position="top" style={{ width: "26rem"}} contentStyle={{ background: '#f7ee9e', display: "flex", justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }} headerStyle={{ background: '#f7ee9e'}} draggable={false} resizable={false} modal onHide={() => setIsOpenError(false)}>
                    <Avatar icon='pi pi-exclamation-triangle' style={{background: '#f7ee9e'}} size='xlarge'/>
                    <span>{errorMsg}</span>
            </Dialog>
            <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5">
                <span className="text-900">Marcación</span>
            </div>
            {localStorage.getItem('tracking') === 'N'?
                <div className='flex justify-content-center'>
                    <Card style={{ width: "60%" }}>
                        <Message severity="info"
                        style={{
                            width: "100%",
                            fontSize: "18px",
                            border: 'solid #696cff',
                            borderWidth: '2px',
                            color: '#696cff'
                        }}
                        content={msgContent}
                        />
                    </Card>
                </div>:
                <div className="card mt-4 w-9 datatable-style-demo">
                    <SkeletonTable load={loadPage}>
                        <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate} />
                        <DataTable className="text-xs" value={markings} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                            selection={markingsSelected} onSelectionChange={(e) => setMarkingsSelected(e.value)} dataKey="PROGRAM_SHIFT_ID" selectionMode="multiple"
                            size="small" filters={filters1} filterDisplay="menu" header={header1} rowClassName={rowClassName}
                            globalFilterFields={['PROGRAM_SHIFT_ID', 'CONTRACT_ID', 'CONTRACT', 'PROGRAM_DATE', 'START_TIME', 'END_TIME', 'COST_CENTER', 'COST_CENTER_ID', 'STATUS_DESC', 'LOV_STATUS_DESC']}
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
                            <Column field="ERROR" header="Error" body={errorBodyTemplate}></Column>
                            <Column field="SHIFT_MARKING_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                            <Column field="PROGRAM_SHIFT_ID" header="ID programación" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID programaión" sortable></Column>
                            <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Contrato" sortable></Column>
                            <Column field="CONTRACT" header="Nombre"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                            <Column field="PROGRAM_DATE" header="Fecha programación"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha programación" sortable></Column>
                            <Column field="START_TIME" header="Hora inicio"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hora inicio" sortable></Column>
                            <Column field="END_TIME" header="Hora fin"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hora fin" sortable></Column>
                            <Column field="RDF" header="RDF"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por RDF" sortable></Column>
                            <Column field="RN" header="RN"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por RN" sortable></Column>
                            <Column field="RNF" header="RNF"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por RNF" sortable></Column>
                            <Column field="HED" header="HED" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por HED" sortable></Column>
                            <Column field="HEDF" header="HEDF"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por HEDF" sortable></Column>
                            <Column field="HEN" header="HEN"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por HEN" sortable></Column>
                            <Column field="HENF" header="HENF"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por HENF" sortable></Column>
                            <Column field="TOTAL_RN" header="Total RN" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por Total RN" sortable></Column>
                            <Column field="TOTAL_HE" header="Total HE" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por Total HE" sortable></Column>
                            <Column field="COST_CENTER" header="Centro de costo contable" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Centro de costo contable" sortable></Column>
                            <Column field="COST_CENTER_ID" header="Código centro de costo contable"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Código centro de costo contable" sortable></Column>
                            <Column field="STATUS_DESC" header="Estado"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                            <Column field="LOV_CAUSAL_DESC" header="Causal"  filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Causal reemplazo" sortable></Column>
                            <Column header="Acciones" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                        </DataTable>
                    </SkeletonTable>
                </div>
                }
        </div>
    )
}

export default Marking
